import React from "react";

const Unauthorized = () => {
  return <div>Sorry you're unauthorized to access this</div>;
};

export default Unauthorized;
